export default {
  greaterThan(value, limit, canBeEqual = false) {
    if (typeof value == 'string') {
      value = parseInt(value)
    }
    if (!value || !limit) {
      return null
    }

    if (canBeEqual) {
      return value >= limit
    }

    return value > limit
  },
}
